import { Injectable, Inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { catchError, distinctUntilChanged, filter, map, of, race, switchMap, tap } from 'rxjs';
import { errorSelectors } from '../selectors';
import { WebAngularSharedUtilErrorHandlingConfig } from '../error-handling-config';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/router";
export class GenericErrorGuard {
    constructor(store, router, zone, errorHandlingOptions = {}) {
        this.store = store;
        this.router = router;
        this.zone = zone;
        this.errorHandlingOptions = errorHandlingOptions;
    }
    canActivate() {
        return this.checkIfNoError().pipe(catchError(() => of(false)), tap(noError => {
            if (!noError && !this.errorHandlingOptions.doNotRedirectOnErrorGuard) {
                this.goToErrorRoute();
            }
        }));
    }
    waitUntil() {
        return of(true);
    }
    /**
     * Checks to see if there are errors after whichever comes first: the waitUntil() function completes, or more errors are added
     *
     * @returns {Observable<boolean>}
     * @memberof GenericErrorGuard
     */
    checkIfNoError() {
        return race(this.waitUntil().pipe(filter(waitDone => waitDone)), this.store.pipe(select(errorSelectors.getErrorCount), distinctUntilChanged(), map(numErrors => numErrors > 0), filter(hasErrors => hasErrors))).pipe(switchMap(() => this.store.pipe(select(errorSelectors.getHasError), map(hasError => !hasError))));
    }
    /**
     * Goes to the error route (/error) unless otherwise set by the options
     *
     * @memberof GenericErrorGuard
     */
    goToErrorRoute() {
        // Changing route in error handling: https://github.com/angular/angular/issues/15946
        this.zone.run(() => this.router.navigate([this.errorHandlingOptions.errorRedirectRoute || '/error']));
    }
    static { this.ɵfac = function GenericErrorGuard_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GenericErrorGuard)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(WebAngularSharedUtilErrorHandlingConfig)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GenericErrorGuard, factory: GenericErrorGuard.ɵfac }); }
}
//# sourceMappingURL=generic-error.guard.js.map